import { Storage } from 'aws-amplify';
import aws_exports from '../aws-exports';

export default function SetS3Config() {
    Storage.configure({
        bucket: aws_exports.aws_user_files_s3_bucket,
        level: "public",
        region: aws_exports.aws_user_files_s3_bucket_region,
        identityPoolId: aws_exports.aws_cognito_identity_pool_id
    });
}